export default "__VITE_ASSET__CNC0p$V___"